export default {
  ja: {
    noMatch: 'エラーあり カスタマーサービスへご連絡下さい',
    220101016: '在庫数不足',
    240000005: '形式不正',
    24000000: '商品詳細は存在しません',
    24130002: '申し訳ございません、この商品は代理購入できません',
    240300011:
      'エラー：該当招待コードに誤りがあります。ご確認いただき、正しく変更してください',
    21000000: '店舗連携失敗',
    21000001:
      '店舗連携失敗　当該店舗は他アカウント連携済、現設定解除後、API連携を再試行して下さい',
    21000002: '店舗名 該当なし',
    21190002: '取込み中、暫くお待ちください',
    21000003: '当該店舗 API未連携',
    21000004: 'エラーあり 時間をおいて再試行して下さい',
    21000005: '111111111',
    21000006: '接続エラー API接続上限時間をおいて再試行して下さい ',
    21000007: '当該店舗 API未連携',
    21000008: '当該店舗 API未連携',
    21000009: '商品取込み失敗',
    21000010: '商品情報取込み失敗',
    21000011: '必須項目productCodeを入力して下さい ',
    21000012:
      '発注ショップ未紐付け連携済店舗商品と発注ショップ情報を紐付けて下さい ',
    21000013: 'API連携済 商品SKU紐付けを実行して下さい',
    21000014: 'SKU紐付け済商品SKU紐付けを解除して下さい ',
    21000015: 'データ同期中',
    21000016:
      '入力不備　API連携用IDまたはAPI連携用secret入力内容を確認し再実行して下さい ',
    21000017: '指定注文 該当なし',
    21000018: '追跡番号更新エラー',
    21000019: 'エラーあり',
    21000020: '指定商品 該当なし',
    21000021: 'アップロードエラー商品情報のアップロードに失敗しました ',
    210000393:
      '商品のプロパティ数が100個超えました，該当商品は自動登録できません',
    21000022: 'API連携されていません、連携してから再試行してください。',
    21000025: '削除不可商品連携済のため削除不可 ',
    21000026: '物流会社 該当なし',
    21000027: '注文処理中、暫くお待ちください',
    21000127: '有効な店舗URLを入力して下さい 例：https://xxx.myshopify.com',
    210001271:
      '入力店舗URL 、またはアクセストークン不備。\n 内容を確認の上、再度お試し下さい',
    21000023:
      '入力店舗URL 、またはアクセストークン不備。\n 内容を確認の上、再度お試し下さい',
    21000028: '注文完了',
    21000029: '仕入れルート不備あり',
    22040010: '納品書をアップロードして下さい',
    24030001: 'デフォルト設定完了済',
    24030002: '必須項目カテゴリーを選択して下さい ',
    24030003: 'カテゴリー 該当なし',
    24030004: 'オプション 該当なし',
    24030005: '設定内容 該当なし',
    24030006: '発送用オプション 設定済',
    24030007: '発送オプション設定不要B2Bユーザはオプション設定不要です ',
    24030008: '当該オプション削除不可',
    24030009: '資材紐付けエラー',
    24030010: 'オプション 該当なし',
    24030011: '指定発送オプション 該当なし',
    24010001: '必須項目 ユーザー名',
    24010002: 'ユーザー名 登録済別ユーザー名を入力して下さい ',
    24010003:
      'ユーザー名またはパスワードが正しくありません',
    24010005:
      'このユーザー名は既に使用されています 別のユーザー名を入力してください',
    24010006: '形式不正 ユーザー名',
    24010007: '氏名を入力して下さい',
    24010008: '形式不正 氏名',
    24010009: '形式不正 氏名12 文字以内で氏名を入力して下さい ',
    24010011: '必須項目 パスワード',
    24010012: 'パスワード（確認用）を入力して下さい',
    24010013: 'パスワード不一致',
    24010015: '新しいパスワードを入力して下さい',
    24010016: '新しいパスワード（確認用）を入力して下さい',
    24010017: 'パスワード入力不備',
    24010018: 'パスワード変更失敗',
    24010019:
      'パスワード入力不備パスワードは、 6~20 文字以内の半角英数で設定して下さい ',
    24010020:
      'パスワード入力不備新パスワードは現パスワードと相違する値を設定して下さい ',
    24010021: 'メールアドレス 登録済。別メールアドレスを入力して下さい ',
    24010022: '必須項目 メールアドレス',
    24010023: 'メール送信失敗',
    24010024: '利用規約に同意後、次へ',
    24010025: '必須項目 国',
    24010026: '電話番号を入力して下さい',
    24010027: '認証コードを入力して下さい',
    24010028:
      '認証コードは無効です。認証コードを再送付し、新しい認証コードを入力してください。',
    24010029: 'メールアドレスは正しくありません。新しいメールアドレスを入力してください',
    24010030: 'メールアドレス 該当なし',
    24010032: 'ユーザー名 該当なし',
    24010033: '当該アカウント停止済',
    24010034:
      '元のメールアドレスと同じため、ご確認の上再度変更の手続きを行ってください', // TODO
    24010035: '銀行口座 該当なし',
    24010036: '貨幣種類を入力して下さい',
    24010038: '必須項目為替レートを入力して下さい ',
    24010040: '必須項目商品IDを入力して下さい ',
    24010041: '必須項目ブランド名を入力して下さい ',
    24010042: '更新失敗ユーザー情報更新に失敗しました ',
    24010043: '形式不正 電話番号正しい電話番号を入力して下さい ',
    24010044: '必須項目仕入れ元を入力して下さい ',
    24010045: '仕入れ元情報不備あり発注ショップ情報に不備あり ',
    24010046: '認証コード申請 更新過多時間を置いて、 再実行して下さい ',
    240100468: '登録されていないメールアドレスです',
    24010049: '形式不正 メールアドレス正しいメールアドレスを入力して下さい ',
    24010068: 'メールアドレス 未登録新規登録を進めて下さい ',
    24020001: '店舗名を入力して下さい',
    24020002: '店舗名 該当なし',
    24020003: '当該店舗 API未連携',
    24020004:
      '子アカウント 店舗作成不可親アカウントにログインし再試行して下さい ',
    24020005: '子アカウント作成完了',
    24020009: '変更不可API連携済のため店舗情報変更不可 ',
    24020008: '連携用ID、連携用secreを入力して下さい',
    240200067: '店舗名 登録済別店舗名を入力して下さい ',
    24200002:
      '上限に達しました本日、 これ以上のおすすめ商品から削除操作はできません ',
    24100001: '店舗名 該当なし',
    24100002: 'システムエラー 暫く経ってから再度お試しください。',
    20000002: 'お支払い中',
    20000003: '注文支払完了',
    20000004: 'お支払い待ち',
    20000005: '発注不可会員登録実施後、 発注可能 ',
    20000007: '商品 該当なし',
    20000008: '注文明細 該当なし',
    20000009: 'お支払い明細 該当なし',
    20000011: '注文清算中',
    20000012: '注文清算完了',
    20000013: 'お支払い失敗',
    20000015: 'キャンセル不可買い付け対応中 ',
    20000017: '必須項目商品IDを入力して下さい ',
    20010001: '残高不足口座残高をチャージして下さい ',
    20020002: '子商品の数を入力して下さい',
    20020003: '必須項目購入数量 ',
    20020004: 'セット組対応済 重複セット組 作成不可 ',
    20020005: 'セット組商品は1点以上設定が必要です',
    20020006: 'セット注文 該当なし',
    20020008: 'セット組注文明細 該当なし',
    20020010: '該当注文書 未精算',
    22050002: '1セット組商品には、単品商品が2件以上必要です',
    22050003: '1注文で最大30点までセット組可能です',
    22050005: 'カート追加失敗',
    22040003: '必須項目発送時オプションを選択して下さい ',
    22040004: '必須項目商品ラベル貼付オプションを選択して下さい ',
    22040005: '国際配送依頼 作成失敗',
    22040006: 'ページを再読み込みして、再度お試し下さい',
    22040007: '為替レート（RMB→ドル） 検索失敗',
    22040008: '在庫ロック失敗',
    22040009: '必須項目箱ラベル貼付オプションを選択して下さい ',
    22010001: '発注不可 商品在庫切れ',
    22010002: '残高不足口座残高をチャージして下さい ',
    22010003: '注文上限額超過D2C直送の注文合計額上限は2000元 / 1 注文 です ',
    22010007: '商品が存在しません',
    22010010: '変更不可検品中のため資材変更不可 ',
    22010011: '商品選択後、カート追加して下さい',
    22010012: '商品skuを入力して下さい',
    22010013: '必須項目購入数量を入力して下さい ',
    22010014: '発注不可 商品在庫切れ',
    22010019: '1商品につき最大10000点までカート追加可能です',
    22010021: '物流会社 該当なし',
    22010025: '操作不可直送注文、 残在庫を利用不可 ',
    22010026: 'キャンセル不可配送済 ',
    22010040: '取消不可審査中状態のみ取消可能 ',
    22010049: '取消不可在庫保管注文 取消不可 ',
    22010051: '分納発送不可在庫保管商品は処理できません ',
    22010052: '分納発送不可配送待ち商品ではなく処理できません ',
    22010057: '店舗名 該当なし',
    22010058: 'AmazonAPI未連携',
    22010060:
      '選択商品 納品対応中出荷済または納品プランキャンセル後、 再試行して下さい ',
    22010064: '購入数量不備購入数量が最低ロット数を満たしていません ',
    22030004: '必須項目商品SKUを入力して下さい ',
    22030005: '必須項目日本倉庫の管理SKUを入力して下さい ',
    22030006: '商品取込失敗当該店舗の商品取込が失敗しました ',
    22030007: 'SKU未紐付けAmazonSKUと未紐付け商品あり ',
    22030008:
      'Amazon上 商品登録情報不備ありAmazon上で修正後、 再試行して下さい ',
    24010062: '登録き期限が切れる',
    10000000: 'ご利用を続行するには、アカウントをログインして下さい',
    22030009: '必須項目 AmazonSKUと紐付けてください ',
    210000390:
      'skuはバインドされていますので、バインドを繰り返さないでください',
    280203014: '口座残高不足 資金をチャージ後、会員費支払いをお願いします',
    24100004: '当商品発注できません、カスタマサービスにご連絡ください',
    28000026: '最低輸送kg数を下回っています',
    210000391: '必須項目：発送用オプションを選択して下さい',
    240300006: '対応中申請があり、処理が完了してから再度申請して下さい',
    24010066: '【ご確認下さい】店舗未登録。店舗作成後、再試行して下さい',
    22010073: '価格を更新された商品あり、最新の商品価格に更新が完了しました。',
    210000394: '在庫不足商品があります',
    26020006: '編集不可　倉庫対応中の商品は編集できません',
    240201001:
      '該当PayPalN支払請求が見つかりません、オンラインカスタマサービスまでご連絡下さい',
    240201002:
      'PayPalからの支払請求ではありません、オンラインカスタマサービスまでご連絡下さい',
    240201003: 'PayPalでの支払いが完了しました',
    240201004:
      'PayPalでの支払い手続きが完了していません、手順に沿ってお支払い手続きを完了してください',
    240201005:
      'PayPalの支払い手続きページには進めません、手順に沿ってお支払い手続きを完了してください',
    240201006: '支払いは完了していません　再度お支払い手続きをお試し下さい',
    240201007:
      '"金融機関に登録されている請求先住所を確認できず、またはカートの利用限度額を超えるため、カード会社にによる決済を拒否されましたお手数ですが、カード発行会社へ直接ご確認下さい"',
    240201008:
      'PayPal での支払いが完了していません　PayPal へ直接お問い合わせ下さい',
    210000395: '商品オプションをご選択下さい',
    26000095:
      '該当物流会社のステータスは表記できないため、お手数ですが、該当物流会社の追跡サイトからご確認くださいませ。',
    22040012: '商品SKUラベルをアップロードして下さい',
    22040011: '箱ラベルをアップロードして下さい',
    24100008: '該当商品が在庫切れのため、商品URLを変更してから再度お試し下さい',
    22010074: '注文商品数は300を超えてはいけません',
    22040013:
      'アップロードデータは追加された商品SKUと異なり、ご確認頂いた上で、再度アップロードして下さい',
    22010075: '既に発送済の注文には、追跡番号の自動反映を解除できません',
    2000008001: '仕入先が同じため、違う商品リンク先を添付してください',
    20000023: 'エラーが発生しました。 理由：再買付回数の上限（3回）に達しました',
    26000082:
      'アフター補償申請不可。アフター補償申請の有効期間は商品購入後2ヶ月以内です',
    22010059: 'お探しの商品が見つかりませんでした',
    28010009: '自社へ一括登録に失敗しました',
    22010081: '該当商品が在庫切れのため、商品URLを変更してから再度お試し下さい',
    22010082: '該当商品が在庫切れのため、商品URLを変更してから再度お試し下さい',
    22041004: 'エラーが発生しました カスタマサービスにご連絡ください',
    240300010: 'メールアドレス 登録済、別メールアドレスを入力して下さい',
    20000018: '発注不可', // API下单失败
    20000019: '一部の発注は失敗しました', // API部分下单失败
    27: '既に振込情報を提出したため、2分後にもう一度お試し下さい',
    22010095: '出荷保留不可 既に出荷済み状態の商品は出荷保留にできません', // 订单拦截 已发货订单不可拦截
    900012: 'このイベントに参加されたことがあります', // 新会员活动 您已参加过此活动,无需重复参加
    900009: 'イベントは終了しました', // 新会员活动 当前活动已结束
    29040003: '該当商品輸出不可',
    220101012: '发货单确认失败',
    220101015:
      '注文書は未承認で完了しており、一時的に優先的に出荷することはできません',
    22010063: 'キャンセル不可 すでにセット組作業中のためキャンセルできません',
    22010029: '下单数量小于转结库存数',
    22110002: '子商品在庫不足',
    22110001: 'キャンセル不可 すでにセット組作業中のためキャンセルできません',
    240300012: '已预约该场直播，无须重复预约',
    350000103: '希望納期は現在の時間よりも過去に設定することはできません',
    35000003: '未提出状態の見積依頼のみを提出可能',
    35000004: '未払い、支払い失敗の注文のみが支払い可能',
    21000038:
      '【ご注意下さい】 該当商品のSKU数が100個を超えるため、店舗に登録できません',
    240300023:
      'このアカウントは既に連携されています。ログインして連携を解除後、ご希望のアカウントで再度お手続きください。',
    240300024:
      '持ちのアカウントは既に別のアカウントに連携されているため、、現在のアカウントとの連合ができませ',
    240300025: '連携に失敗しました。 このアカウントは対象外です。',
    240300027: '連携は無効となります。改めてAPI連携を行ってください。',
    24010054:
      '認証コードが無効です。再度コードを取得し、正しい認証コードを入力してください。',
    24010052:
      '認証コード無効 認証コードを再送付し、正しい認証番号を入力して下さい',
    24010055:
      'この電話番号は既に登録されています。他の電話番号を登録してください',
    24010056: 'この電話番号は登録されていません',
    219100001: '透かし無し画像のダウンロード回数が上限に達しました',
    240300007:
      '認証エラーが続いたため、30分間このメールアドレスでの登録はできません。時間をおいて再試行するか、別のアドレスをご利用ください。',
    220101019: '【エラー】ブランドライセンス未取得の商品があります',
    240000011: '【エラー】当該ブランドが出品停止になりました',
    // 241000004: '신【エラー】ブランドライセンス申請のキャンセルはできません',
    241000005: '【エラー】ブランドライセンス申請のキャンセルはできません',
    241000006: '【エラー】当該ブランドの操作ステータスがすでに変更されました',
    241000008: '【エラー】重複して申し込むことはできません',
    22040014: 'メールアドレスを入力してください',
    240000012: 'エラーが発生しました ブラックリストに載っている商品は仕入れできません',
    29040005: 'エラーが発生しました ブラックリストに載っている商品は仕入れできません',
    240000015: '一括分納発送を行う注文は最大200件までです',
    240000016: '選択された注文は分納発送できません',
    240000017: 'すでにバッチ処理中です。分納発送をご希望の場合は、注文を個別に処理して下さい',
    22010092: 'OEM在庫不足のため、発注できません',
    21000036: 'API連携情報が更新されました。画面をリフレッシュしてから再度お試し下さい',
    240000018: 'エラーが発生しました。１Amazon ASINにあたり、紐付けできるCKB SKUは最大３つまでです',
    22041027: '同じAmazon skuを持つ、違う仕入れ先から仕入れた商品があります。 新規納品プランを作成し、重複している商品を分割発送してください',
    210000403: '１店舗商品SKUあたり、紐付けできるCKB SKUは最大３つまでです。他SKU紐づけを解除した上、再度お試し下さい',
    22030001: '店舗アカウントが切り替えられため、商品データを読み取れませんでした。 引き続き紐付けするには、元店舗に切り替えて下さい',
    210000404: 'エラーが発生しました。当該商品は同時に複数の店舗商品と紐付けすることができません',
    21000403: '１店舗商品SKUあたり、紐付けできるTHE CKB SKUは最大３つまでです。他SKU紐づけを解除した上、再度お試し下さい',
    240000020: 'データが更新されたため、オプションを再編集する必要があります',
    210000402: '１商品につき最大３0つまで、仕入れ商品SKU（THE CKB SKU）と紐付けできます',
    240000014: '購入数量が最低ロット数を満たしていません',
    240000038: '一度アップロードできるのは、最大1,000行までです。',
    240300016: 'テンプレート名に重複が発生しています。重複内容を削除した後、再アップロードして下さい',
    240300017: 'デフォルトの洗濯タグを設定して下さい',
    22030012: '該当商品のデータが見つかりませんでした。自社サイトでご確認の上、再度お試しください',
    // 店铺未配置水洗标模版
    240000035: 'エラーが発生しました。洗濯タグ仕様が設定されていません',
    29050003: '申し訳ありませんが、このショップの商品は仕入れできません',
    29030006: '申し訳ありませんが、このショップの商品は仕入れできません',
    40000203: 'エラーが発生しました： 異なる国からの商品とは紐付けられません',
    200000046: '異なる国からの商品を同時に注文することはできません。各国の商品は別々のカートからご注文ください',
    22050012: 'エラーが発生しました 当該ブランドが出品停止になりました',
    22050013: 'エラーが発生しました ブランドライセンス取得が必要となります',
    22050014: 'このセット組商品は現在の店舗には属していません。',
    // 该品牌已被独家授权
    241000017: 'このブランドは他社から独占的にライセンスを受けています',
    300000005: 'このページではアクセスがサポートされていません。',
    240000030: 'ご注文商品のSKUが重複しておりますので、ショッピングカート内の商品をご確認ください。',
    22010091: 'まだ支払われていない注文は返金することができます。',
    240000043: '注文は支払済みのため、商品オプションを選択することができません。',
    281000015: 'エラーが発生しました。同じ商品カテゴリーのオールインオプションセットが既に存在しています。',
    20001006: 'エラーが発生しました。商品バリエーションを選択してください',
    // 240000048: '',
    240000049: '現在の会員プラン（フリー会員）では、一部のオプションをご利用いただけません。会員プランをアップグレードするか、オプションを削除した後に再度お試しください。',
    240000050: '現在の会員プラン（フリー会員）では、ECサイト商品と市場・問屋商品のみ注文可能です。アップグレード後に再度お試しください。',
    22040018: '利用可能な運送会社が見つかりません。お手数ですが、担当者またはカスタマサービスまでご連絡ください。',
    241000004: 'このカテゴリの商品は最低発注数量に達していないため、注文できません。',
    241000001: '現在ご利用中の店舗では、「CKB Choice」商品を購入することはできません。',
    200000053: 'この商品はブラックリストに登録されています。新しい発注リンクを選択してください。',
    20001021: 'オールイン価格注文は発注リンクの変更に対応しておりません。再度操作をお願いします。',
    242000006: 'このセット商品には日本円価格商品が含まれており、注文できません。ご確認のうえ、再度組み合わせてください',
    22010084: '【ご注意下さい】在庫切れの商品があるため、購入できません',
    24100000: 'URL検索の上限に達しました。',
    31011001: '無効なコードです',
    31011003: 'このキャンペーンは終了しました',
    31040007: 'すでにこのキャンペーンに参加済みです',
    31040008: '参加条件を満たしていません',
    22040020: '商品にMSKUが未入力です。',
    22040021: 'CROSS MALL SKU未指定商品あり　CROSS MALL SKUと紐付けして下さい',
    260000003: '日本倉庫直送の組合わせ注文において、商品在庫が不足している場合は、先に在庫を確保してください',
    24200001: '商品不存在',
    26160012: '追加した内容は既に存在しています',
    40000303: '商品登録に失敗しました。カスタマーサービスまでご連絡ください。',
    // 40000304: '创建商品失败，商品sku字段缺失:{0}',
    40000305: '登録しようとした商品はすでに存在しています。', // 创建商品已经存在
    40000306: 'SKU情報が未設定です。商品情報をご確認ください。',
    26160013: '受信追跡番号はすでに存在するため、更新できません。',
    240000002: 'この製品はサポートされていません。',
    40000309: '該当注文は自動発注に対応していません',
    240000037: 'お客様商品規格（洗濯タグ用）は20文字以内で入力してください。',
    40000310: 'エンドユーザー様のご都合により、この注文はキャンセルされました。対応や発注の必要はありません。'
  },
  ko: {
    noMatch: '에러있음, 고객 서비스센터로 연락주십시오',
    24220002: '점포를 추가하지 않으셨으니 점포를 먼저 추가하세요.',
    24000000: '제품 세부정보가 존재하지 않습니다.',
    240300007:
      '비밀번호가 30분 이내에 5회 이상 틀리면 이메일로 로그인해주세요.',
    219100001: '워터마크 없음 사용 횟수가 상한에 도달했습니다.',
    24130002: '죄송하지만 해당 상품은 구매대행 불가합니다.',
    24010054: '인증번호가 일치하지 않습니다. 인증번호를 다시 확인해 주세요.',
    24010055: '해당 핸드폰 번호는 이미 등록되어 있습니다. 다시 입력해 주세요.',
    24010056: '휴대폰번호가 존재하지 않습니다. 다시 입력해 주세요.',
    21000000: '상점 허가 실패',
    24010052: '',
    21000001:
      '해당 매장은 다른 계정으로 이미 바인딩되어 있으니, 먼저 잠금 해제 후 다시 시도하십시오.',
    21000002: '매장명 해당없음',
    21000003: '아직 상점이 허가되지 않았습니다.',
    21000004: 'Base 스토어 새로 고침 실패',
    21000005: '111111111',
    21000006:
      'Base 주문내역 인터페이스 가져오기: 현재 시간 내 인터페이스 요청 횟수가 초과되었습니다.잠시 후 다시 시도해 주십시오',
    21000007: 'Base 주문 내역 가져오기 실패',
    21000008: '해당 매장이 아직 연계되지 않았습니다.',
    21000009: 'Base 스토어 상품 목록 취득 실패',
    21000010: 'Base 스토어 상품 상세정보 취득 실패',
    21000011: 'ProductCode는 비워 둘 수 없음',
    21000012: '매장 상품을 먼저 묶어야 합니다.',
    21000013:
      '매장상품은 결제가 되었으므로 해당상품의 SKU만 결제가 가능합니다.',
    21000014: '먼저 상품의 SKU를 풀어야 합니다.',
    21000015: '매장이 이미 동기화 중입니다',
    21000016: '매장앱ID 또는 앱키 미비, 매장정보 편집',
    21000017: '주문이 존재하지 않습니다',
    21000018: '반송물류전표번호이상',
    21000019: '에러가 발생했습니다.',
    21000020: '제품이 존재하지 않습니다',
    21000021: '상품정보업로드에실패하였습니다',
    210000393: '상품수량 100개 이상, 해당 상품 자동 업로드 불가',
    21000022: '매장 URL 형식이 잘못되었습니다. ',
    21000025: '상품이 결속되어 있어 삭제할 수 없습니다',
    21000026: '물류 및 화물 대리인이 존재하지 않습니다.',
    21000027: '이 주문서는 지금 주문중입니다.',
    21000028: '이 주문서는 이미 주문이 성공하였습니다.',
    21000029: '구매 경로가 정확하지 않습니다.',
    22040010: '납품서를 업로드 해 주세요.',
    24030001: '기본 설정 항목이 이미 존재합니다',
    24030002: '설정 항목 집합은 비워 둘 수 없습니다',
    24030003: '분류조회 실패',
    24030004: '사용자 추가 정보 조회 실패',
    24030005: '설정 항목이 없습니다',
    24030006: '국제물류배치추가항목이존재함',
    24030007: 'b2b 사용자 국제 물류 구성 추가 사항 필요 없음',
    24030008: '이 추가 항목은 삭제할 수 없습니다.',
    24030009: '부자재 연관 실패',
    24030010: '이 장면의 사용자 추가 항목이 없습니다',
    24030011: '물류 추가 항목이 없습니다',
    24010001: '로그인 이름은 중복할 수 없습니다',
    24010002: '잘못된 로그인 이름 또는 비밀번호',
    24010003: '로그인 이름이 이미 존재합니다',
    24010005: '이미 사용중인 아이디 입니다.',
    24010006: '잘못된 로그인 이름 형식',
    24010007: '연락처 이름은 비워 둘 수 없습니다',
    24010008: '연락처 이름 형식이 잘못되었습니다.',
    24010009: '연락처 이름 길이는 0-12자로 제한됨',
    24010011: '비밀번호는 비워둘 수 없습니다',
    24010012: '비밀번호에 빈칸이 없는지 확인해주세요',
    24010013: '비밀번호가 일치하지 않습니다.',
    24010015: '새로운 비밀번호에 빈칸을 사용할 수 없습니다.',
    24010016: '새로운 비밀번호에 빈칸이 없는지 확인해 주세요',
    24010017: '새 비밀번호 확인은 비워둘 수 없습니다',
    24010018: '기존 암호가 올바르지 않습니다.',
    24010019: '비밀번호 수정 실패',
    24010020: '비밀번호가 일치하지 않습니다.',
    24010021: '이메일이 이미 존재합니다',
    24010022: '이메일을 비워둘 수 없습니다',
    24010023: '메일 보내기 실패',
    24010024: '이용약관에 동의하세요',
    24010025: '국가/주소 코드는 비워 둘 수 없습니다',
    24010026: '핸드폰 번호는 비워둘 수 없습니다',
    24010027: '이메일 인증 코드는 비워 둘 수 없습니다',
    24010028: '잘못된 인증 번호',
    24010029: '잘못된 이메일 형식',
    24010030: '이메일이 존재하지 않습니다',
    24010032: '아이디 또는 비밀번호를 잘못 입력했습니다.입력하신 내용을 다시 확인해주세요.',
    24010033: '고객이 존재하지 않습니다',
    24010034: '新邮箱不能与原邮箱相同', // TODO
    24010035: '로그인한 사용자가 비활성화됨',
    24010036: '화폐 종류를 입력하세요.',
    24010038: '환율은 비워둘 수 없습니다.',
    24010040: '고객 ID는 비워 둘 수 없습니다',
    24010041: '브랜드명은 비워둘 수 없습니다',
    24010042: '사용자 업데이트 실패',
    24010043: '전화 형식이 잘못되었습니다.',
    24010044: '시스템 출처를 비워둘 수 없음',
    24010045: '시스템 출처가 잘못되었습니다.',
    24010046: '메일 요청 속도가 너무 빠릅니다',
    240100468: '우편함이 등록되지 않았습니다',
    24010049: '잘못된 이메일 형식',
    24010068: '등록되지 않은 이메일 입니다.회원가입을 해주세요.',
    24020001: '점포명은 비워둘 수 없습니다',
    24020002: '점포가 존재하지 않습니다',
    24020003: '해당 매장이 아직 연계되지 않았습니다.',
    24020004: '부계정은 매장추가 불가',
    24020005: '점포가 활성화되었습니다',
    24020009: '점포가 허가되어 점포 정보를 수정할 수 없습니다.',
    24020008: '응용 프로그램 ID와 응용 프로그램 키를 입력해야 합니다.',
    240200067: '점포명이존재함',
    24200002: '싫어하는 상품이 오늘 이미 최대수에 다달했습니다',
    24100001: '점포가 존재하지 않습니다',
    24100002: '싫어하는 가게가 오늘 이미 최대수에 다달했습니다',
    20000002: '주문지불중',
    20000003: '주문지불완료',
    20000004: '주문대기중',
    20000005: '고객이 회원이 아니므로, 주문을 할 수 없습니다.',
    20000007: '주문 중 상품 없음',
    20000008: '주문내역이 존재하지 않습니다',
    20000009: '주문 지불 데이터가 존재하지 않습니다.',
    20000011: '주문결제중',
    20000012: '주문이 이미 청산되었다',
    20000013: '주문 미지급 성공',
    20000015: '처리 대기 상품 주문서만 취소',
    20000017: '고객 ID를 비워둘 수 없음',
    20010001: '지갑잔고부족',
    20020002: '조합 수량(참고)는 비워 둘 수 없습니다',
    20020003: '조합 수량이 0보다 커야 합니다',
    20020004: '이 상품은 조합이 이미 존재하므로 중복 추가할 수 없습니다',
    20020005: '조합상품의 총 수량은 1보다 커야 합니다',
    20020006: '상품 주문 조합이 존재하지 않습니다',
    20020008: '상품주문조합내역이존재하지않습니다',
    20020010: '고객상품주문미완성정산',
    22050002: '결합상품이 서브상품이 하나뿐인 경우 한 세트 수량은 >=2',
    22050003: '조합상품에 포함된 하위상품 수는 <=30',
    22050005: '장바구니에 추가하지 못했습니다.',
    22040003: '필수 항목 배송 옵션을 선택하십시오',
    22040004: '필수 항목 제품 라벨 붙여넣기 옵션을 선택하세요.',
    22040005: '국제 배송 요청 작성에 실패했습니다.',
    22040006: '배송 가능한 수량 부족',
    22040007: '환율(CNY→달러) 검색에 실패했습니다.',
    22040008: '잠금 실패.재고 잠금에 실패했습니다.',
    22040009: '필수 항목 상자 라벨 붙여넣기 옵션을 선택하십시오',
    22010001: '실효된 상품은 주문이 안 된다.',
    22010002: '잔고부족 계좌잔액을 충전해 주세요',
    22010003:
      '1000위안 이상 주문하려면 B2B 페이지로 이동해서 주문하시기 바랍니다!',
    22010007: '쇼핑 카트는 비워둘 수 없습니다.',
    22010010:
      '플랫폼 주문서의 상세한 내용은 이미 품질 검사를 하였으므로 부자재를 수정할 수 없습니다.',
    22010011: '쇼핑 카트 가입 상품은 비워둘 수 없습니다',
    22010012: '플랫폼 상품 SKU는 비워둘 수 없습니다',
    22010013: '필수 항목 구매 수량을 입력하십시오.',
    22010014: '주문 불가 상품이 품절되어 주문할 수 없습니다.',
    22010019: '하나의 상품에 최대 10000 포인트까지 장바구니에 추가',
    22010021: '물류회사 해당없음',
    22010025: '직발주문은 이월주문 잔여조합수가 허용되지 않습니다',
    22010026: '발송 취소 불가',
    22010040: '취소는 업무 처리 중에만 가능합니다.',
    22010049: '재고 주문은 보류 중인 구매가 아니며 취소할 수 없습니다.',
    22010051: '재고 주문은 우선 배송을 지원하지 않습니다.',
    22010052: '현재 상품은 배송대기 상태가 아니며 우선배송 불가',
    22010057: '매장명 해당없음',
    22010058: '아마존에서 승인하지 않은 매장',
    22010060:
      '제품이 보충 계획에 있습니다. 보충을 완료하거나 보충 계획을 취소한 후 교체 작업을 수행하십시오.',
    22010064: '대형 품목의 구매 수량은 MOQ 이상이어야 합니다.',
    22030004: '매장 제품 SKU 데이터가 비어 있습니다.',
    22030005: '매장 상품 해외 창고 SKU가 비어 있습니다.',
    22030006: '매장 상품 재고 데이터 획득 실패',
    22030007: 'Store SKU는 Amazon에 바인딩되지 않습니다.',
    22030008:
      '아마존 상품이 완벽하지 않으니, 아마존 플랫폼으로 상품 정보를 보완해 주시기 바랍니다.',
    24010062: '등록 기한이 지났습니다',
    10000000: '이용을 계속하시려면 계정을 로그인해주세요',
    22030009: '매장 SKU에 아마존 SKU가 부족함',
    210000390: 'SKU가 성공적으로 연결되었습니다. 반복하지 마십시오.',
    280203014: '계좌 잔액 부족합니다! 충전후 회원비 다시 지불하시기 바랍니다!',
    24100004: '본상품 발주가 불가능 합니다. 고객서비스로 연락주세요',
    28000026: '최소 수송 kg 아래로 떨어졌습니다',
    210000391: '필수 항목 : 발송용 옵션을 선택하세요.',
    240300006: '대응 중, 처리 완료 후 재신청 바랍니다',
    24010066: '【확인하세요】매장 미등록.매장등록후 재시도해주세요',
    22010073:
      '가격을 갱신하신 상품이 있어 최신 상품 가격으로 갱신이 완료되었습니다.',
    210000394: '재고 부족 상품이 있습니다.',
    26020006: '편집 불가, 창고에 대응중인 상품은 편집할 수 없습니다',
    240201001:
      '해당 PayPalN 지불 청구를 찾을 수 없습니다, 온라인 고객 서비스로 연락 주십시오.',
    240201002: 'PayPal결제가 아니니 고객센터로 문의바랍니다',
    240201003: 'PayPal 지불이 완료되었습니다.',
    240201004:
      '결제 절차가 완료되지 않았습니다. 절차에 따라 결제 절차를 완료해 주세요.',
    240201005:
      'PayPal 결제 절차 페이지로 넘어가지 않습니다. 절차에 따라 결제 절차를 완료해 주세요.',
    240201006: '지불이 완료되지 않았습니다. 다시 지불 절차를 밟아 주십시오.',
    240201007:
      '금융기관에 등록된 청구처 주소를 확인하지 못하거나 카트 이용한도가 초과되어 카드사 결제가 거부되어 번거로우시더라도 카드 발급사로 직접 확인하시기 바랍니다',
    240201008:
      'PayPal에서의 지불이 완료되지 않았습니다. PayPal로 직접 문의해 주십시오.',
    210000395: '상품 옵션을 선택하세요',
    26000095:
      '해당 물류 진행 상황을 파악할 수 없으므로 해당 물류회사 홈페이지에서 물류 상태를 확인해주시길 바랍니다.',
    22040012: '상품SKU라벨을업로드해주세요',
    22040011: '상자 라벨을업로드해주세요',
    24100008: '해당 상품이 재고가 소진되었습니다.',
    27: '이미 이체 정보를 제출했으니 2분 후에 다시 시도해주세요.',
    900009: '이벤트는 종료되었습니다.',
    900012: '이 행사에 참가하신 적이 있습니다.',
    20000018: '발주 불가',
    20000019: '일부 발주는 실패했습니다',
    21000023:
      '입력 점포 URL 또는 액세스 토큰 미비.\\n 내용 확인 후 다시 시도해주세요.',
    21000127: '유효한 점포 URL을 입력해 주세요. 예：https://xxx.myshopify.com',
    21190002: '주문 접수 중 잠시만 기다려 주십시오',
    22010063: '취소 불가 이미 세트조 작업중이므로 취소할 수 없습니다.',
    22010074: '주문 상품 수는 300을 초과해서는 안됩니다.',
    22010075: '이미 발송된 주문에는 추적 번호 자동 반영을 해제할 수 없습니다.',
    22010081: '해당상품 재고소진으로 상품URL변경후 다시 시도해주세요',
    22010082: '해당상품 재고소진으로 상품URL변경후 다시 시도해주세요',
    22010095:
      '출하 보류 불가 이미 출하한 상태인 상품은 출하 보류가 불가능합니다.',
    22040013:
      '업로드 데이터는 추가된 상품 SKU와 다르니 확인하시고 다시 업로드 해주세요.',
    22041004: '에러가 발생했습니다. 고객 서비스로 연락주세요.',
    22110001: '취소 불가 이미 세트조 작업중이므로 취소할 수 없습니다.',
    22110002: '자상품 재고 부족',
    26000082:
      'A/S 보상 신청 불가.A/S 보상 신청 유효기간은 상품 구입 후 2개월 이내입니다.',
    28010009: '자사에 일괄 등록에 실패했습니다.',
    29040003: '해당상품수출불가',
    210001271:
      '입력 점포 URL 또는 액세스 토큰 미비.\\n 내용 확인 후 다시 시도해주세요.',
    220101015:
      '주문서는 미승인으로 완료되어 일시적으로 우선 출하할 수 없습니다.',
    240300010: '메일 주소 등록 완료, 다른 메일 주소를 입력해 주세요.',
    240300011:
      '오류: 해당 초대 코드에 오류가 있습니다.확인하시고 올바르게 변경해주세요.',
    350000103: '예상 납기 시간은 현재 시간보다 작을 수 없습니다.',
    35000003: '게시할 상태의 원본 목록만 게시할 수 있습니다.',
    35000004: '미지급 또는 결제 실패 또는 결제 성공 주문만 결제가 가능합니다.',
    240300023:
      '이 계정은 이미 삼자 플랫폼 계정과 연동되어 있습니다. 먼저 연결을 해제하십시오.',
    240300024:
      '지금 계정은 이미 다른 계정으로 연계되어 현재 계정을 연계할 수 없습니다.',
    240300025: '연계 실패했습니다. 이 계정 연계은 지원되지 않습니다.',
    240300027: '권한이 이미 만료되었으니, 다시 권한을 부여해 주십시오.',
    220101019: '미승인 브랜드 상품이 존재합니다.',
    240000011: '브랜드는 이미 퇴출되었습니다.',
    // 241000004: '신청번호가 비어있습니다!',
    241000005: '브랜드 승인 신청은 취소가 불가능합니다!',
    241000006: '본 브랜드 승인 상태를 이미 변경되어있습니다.',
    241000008: '승인 요청내역이 존재하니 중복 신청하지 마시기 바랍니다!',
    22040014: 'メ이메일 주소를 입력해 주세요',
    240000012: '블랙리스트에 있는 상품은 주문이 불가합니다. ',
    29040005: '블랙리스트에 있는 상품은 주문이 불가합니다. ',
    240000015: '대량 유한출고가 제한을 초과하여 200을 제한합니다',
    240000016: '선택한 주문은 우선적으로 발송할 수 없습니다',
    240000017: '조기 발송 작업이 이미 존재합니다',
    22010092: 'OEM 재고부족으로 주문실패',
    21000036: '점포 연동 관계 수정 발생, 창 새로 고침을 해주세요.',
    240000018: '연동된 상품의 개수가 한도를 초과하였습니다.',
    22041027: '동일한 Amazon sku가 존재하므로 분할하여 발송해 주시기 바랍니다.',
    210000403: '현재 3번 플랫폼 제품에 제본된 제품의 개수가 3개 이상이니 운영 전에 3개 미만으로 만들어 주세요.',
    22030001: '제품이 매장에 없습니다, 다시 시도해보세요. ',
    210000404: '3자 상품 관련은 다대다를 허용하지 않습니다.',
    21000403: '현재 3번 플랫폼 제품에 제본된 제품의 개수가 3개 이상이니 운영 전에 3개 미만으로 만들어 주세요.',
    240000020: '선택하신 부가항목을 업데이트 했습니다! 다시 선택하시길 바랍니다!',
    210000402: '최대 30개 상품 등록 가능',
    240000014: '구매 수량이 최소 로트 수를 충족하지 못했습니다.',
    240000038: '테이블 데이터는 최대 1000줄입니다.',
    240300016: '',
    22030012: '매장상품이 존재하지 않습니다',
    20000023: '재구매 횟수 이미 도착했습니다',
    // 店铺未配置水洗标模版
    240000035: '점포에서 워싱라벨 미설정',
    29050003: '해당 가게는 구매시장에 없습니다',
    29030006: '해당 가게는 구매시장에 없습니다',
    22050014: '이 조합 상품의 SKU는 현재 상점에 속해 있지 않습니다.',
    241000017: '해당 브랜드는 다른 사람에 의해 독점 라이센스를 받았습니다.',
    240000030: '주문한 상품의 SKU가 중복되어 장바구니에 담긴 상품을 확인해주세요.',
    22010091: '아직 결제되지 않은 주문에 대해서는 환불이 가능합니다.',
    20001006: '규격을 선택하십시오.',
    240000049: '비회원은 해당 추가 주문을 지원하지 않으니, 회원 업그레이드 바랍니다.',
    240000050: '비회원은 일반상품만 주문 가능하니 회원 업그레이드 바랍니다.'

  },
  en: {
    noMatch: 'Error, please contact customer service center',
    27: 'The remittance information has been submitted. Please try again in 2 minutes',
    900009: 'The activity has ended',
    900012: 'You have participated in this activity',
    10000000: 'If you want to continue using, please login to your account',
    20000002: 'Payment in progress',
    20000003: 'Order payment completed',
    20000004: 'Waiting for payment',
    20000005:
      'Not available for ordering now, members can order after registering',
    20000007: 'No such order',
    20000008: 'No details for this order',
    20000009: 'No payment details available',
    20000011: 'Order clearing in progress',
    20000012: 'Order Clearing Complete',
    20000013: 'Payment failed',
    20000015: 'Purchase correspondence cannot be cancelled',
    20000017: 'Required item, please enter product ID',
    20000018: 'Not orderable',
    20000019: 'Some orders failed',
    20000023: 'Reaching the maximum number of retakes',
    20010001: 'Insufficient account balance, please recharge',
    20020002: 'Please enter the quantity of sub products',
    20020003: 'Purchase quantity of mandatory items',
    24220002: 'You have not added a shop, please do so first.',
    20020004:
      'The combination product has already been created, do not create it again',
    20020005: 'Package products require two or more products to be established',
    20020006: 'There are no products in this combination',
    20020008: 'There are no product details for this combination',
    20020010: 'The order has not been settled',
    21000000: 'Store link failed',
    21000001:
      'Store connection failed. The store is already bound to another account. Please unbind and try again',
    21000002: 'There is no such store name',
    21000003: 'The store API is not linked',
    21000004: 'Error, please try again after a period of time',
    21000005:
      'one hundred and eleven million one hundred and eleven thousand one hundred and eleven',
    21000006: 'Connection error API connection limit time and retry',
    21000007: 'The store API is not connected',
    21000008: 'The store API is not connected',
    21000009: 'Product purchase failed',
    21000010: 'Product information acquisition failed',
    21000011: 'Please enter the required product code',
    21000012:
      'Please associate the store products that have not been associated with the ordering store with the ordering store information',
    21000013:
      'Please execute API connection to complete product SKU association',
    21000014: 'Please dissociate the SKU associated with the product SKU',
    21000015: 'Data synchronization in progress',
    21000016:
      'Please confirm the incomplete input of API synergy ID or API synergy secret and execute it again',
    21000017: 'The specified order is not applicable',
    21000018: 'Update tracking number error',
    21000019: 'There are errors',
    21000020: 'The specified product does not exist',
    21000021: 'Upload error: Product information failed to upload',
    21000022: 'The API is not connected. Please connect and try again.',
    21000023:
      'The URL or access token for the entered store is incomplete. Please confirm and try again',
    21000025:
      'The product cannot be deleted. It is already connected and cannot be deleted',
    21000026: 'The logistics company does not exist',
    21000027: 'Order processing, please wait',
    21000028: 'Order completion',
    21000029: 'Incomplete procurement channels',
    21000038:
      'Please note that the number of SKUs for this product exceeds 100 and cannot be registered in the store',
    21000127:
      'Please enter a valid store URL example: https://xxx.myshopify.com',
    21190002: 'Ordering in progress, please wait',
    22010001: 'Product inventory is full and cannot be ordered',
    22010002: 'Insufficient account balance, please recharge',
    22010003:
      'The total amount of product tokens for an order cannot exceed 2000 RMB per person',
    22010007: 'Product does not exist',
    22010010:
      'Material cannot be changed in the non modifiable inspection sample',
    22010011: 'After selecting the product, please add a shopping cart',
    22010012: 'Please enter product SKU',
    22010013: 'Required items, please enter the purchase quantity',
    22010014: 'The inventory of non orderable items is full',
    22010019:
      'Each product can be added up to 10000 items in the shopping cart',
    22010021: 'Not applicable to this logistics company',
    22010025:
      'Direct order cannot be operated, remaining inventory cannot be used',
    22010026: 'Shipped and cannot be cancelled',
    22010029:
      'The order quantity is less than the transferred inventory quantity',
    22010040: 'Only products in the review status can be reviewed',
    22010049: 'Non cancellable inventory storage orders cannot be cancelled',
    22010051: 'Sending inventory storage products cannot be divided and sent',
    22010052:
      'Products that are not in a pending status cannot be distributed and sent',
    22010057: 'Order does not exist',
    22010058: 'Amazon API not connected',
    22010060: 'Select the corresponding shipped item for delivery',
    22010063:
      'Cannot be cancelled. It cannot be cancelled in the combination product operation',
    22010064:
      'Incomplete procurement quantity does not meet the minimum batch quantity',
    22010073:
      'There are products with updated prices, which have been updated to the latest product prices.',
    22010074: 'The quantity of ordered products cannot exceed 300',
    22010075:
      'The reflection that the tracking number cannot be automatically canceled for orders that have been sent',
    22010081:
      'Because the product is no longer in stock, please change the product URL and try again',
    22010082:
      'Because the product is no longer in stock, please change the product URL and try again',
    22010095:
      'Products that cannot be suspended for shipment cannot be suspended for shipment',
    22030004: 'Please enter a required item SKU',
    22030005: 'Please enter the required SKU for managing Japanese warehouses',
    22030006: "Product reading failed. The store's product reading failed",
    22030007: 'There are SKUs and products that are not associated with Amazon',
    22030008:
      'The product registration information on Amazon is incomplete. Please modify it on Amazon and try again',
    22030009: 'Required items, please associate with Amazon SKU',
    22040003: 'Mandatory items, please select the option when sending',
    22040004:
      'Required items, please select the option to paste the product label',
    22040005: 'International delivery commission production failed',
    22040006: 'Insufficient Deliverable Quantity',
    22040007: 'Exchange rate (RMB → USD) search failed',
    22040008: 'Inventory locking failed',
    22040009: 'Required items, please select the option of pasting box labels',
    22040010: 'Please upload the delivery note',
    22040011: 'Please upload the box label',
    22040012: 'Please upload the product SKU label',
    22040013:
      'The uploaded data is different from the added product SKU. Please confirm before uploading',
    22041004: 'An error occurred, please contact customer service',
    22050002: 'A set of products requires two or more individual items',
    22050003: 'One order can hold up to 30 pieces',
    22050005: 'Failed to add shopping cart',
    22110001: 'Unable to cancel already in assembly operation',
    22110002: 'Insufficient inventory of sub items',
    24010001: 'Required username',
    24010002: 'Please enter a registered username',
    24010003:
      'Illegal format username or password. Please enter the correct format username or password',
    24010006: 'Format illegal username',
    24010007: 'Please enter your name',
    24010008: 'Format illegal name',
    24010009: 'Incorrect format. Please enter a name within 12 characters',
    24010011: 'Required password',
    24010012: 'Please enter the password (for confirmation)',
    24010013: 'Password mismatch',
    24010015: 'Please enter a new password',
    24010016: 'New password (confirm)',
    24010017: 'Incomplete password input',
    24010018: 'Password change failed',
    24010019:
      'Incomplete password input, please set it to half width English characters or less',
    24010020:
      'Incomplete password input. Please set a value different from the current password for the new password',
    24010021:
      'Registered email address. Please enter a different email address',
    24010022: 'Required field email address',
    24010023: 'Email sending failed',
    24010024:
      'After agreeing to the terms of use, please proceed to the next step',
    24010025: 'Required Country/Region',
    24010026: 'Please enter a phone number',
    24010027: 'Please enter the authentication code',
    24010028:
      'Invalid authentication code. Please resend the authentication code and enter the correct authentication number',
    24010029: 'Format illegal email address',
    24010030: 'Does not match email address',
    24010032: 'User name not applicable',
    24010033: 'This account has been deactivated',
    24010034:
      'Because it is the same as the original email address, please confirm before proceeding with the change procedure',
    24010035: 'The bank account does not exist',
    24010036: 'Please enter the currency type',
    24010038: 'Required item, please enter exchange rate',
    24010040: 'Required item, please enter product ID',
    24010041: 'Required items, please enter a brand name',
    24010042: 'Update failed Update failed user information',
    24010043:
      'Phone number format error. Please enter the correct phone number',
    24010044: 'Required items, please enter the supplier',
    24010045:
      'Incomplete supplier information, incomplete ordering store information',
    24010046:
      'The authentication code application operation is too frequent, please try again after a period of time',
    240100468:
      'Email is not registered',
    24010049:
      'The email address format is illegal. Please enter the correct email address',
    24010062: 'Expiration of registration period',
    24010066:
      'Please confirm that the store is not registered. After creating the store, please try again',
    24010068:
      'If the email address is not registered, please register on the new registration page',
    24020001: 'Please enter the store name',
    24020002: 'There is no such store name',
    24020003: 'The store API is not associated',
    24020004:
      'Unable to create. Please login to the main account again and try again',
    24020005: 'Sub account creation completed',
    24020008: 'Please enter the collaboration ID and collaboration secret',
    24020009:
      'The non modifiable API is already associated, therefore the store information cannot be changed',
    24030001: 'Default settings completed',
    24030002: 'Please select a required category',
    24030003: 'Not belonging to category',
    24030004: 'Option not applicable',
    24030005: 'Setting content not applicable',
    24030006: 'Shipping options have been set',
    24030007:
      'No need to set shipping options   B2B users do not need to set options',
    24030008: 'Unable to delete the option',
    24030009: 'Material link error',
    24030010: 'Option not applicable',
    24030011: 'The specified shipping option is not applicable',
    24100001: 'Does not match store name',
    24100002:
      'The URL does not exist. Please confirm the entered URL and try again',
    24100004: 'Unable to order this product, please contact customer service',
    24100008: 'This product is no longer in stock',
    24200002:
      'The maximum number of operations reached today, and the above recommended products cannot be deleted',
    26000082:
      'Unable to apply for after-sales compensation. The validity period for applying for after-sales compensation is within 2 months after purchasing the product',
    26000095:
      'Because the status of the logistics company cannot be marked, please confirm from the tracking website of the logistics company.',
    26020006:
      'The products in the corresponding non editable warehouse cannot be edited',
    28000026: 'Less than the minimum transported kilograms',
    28010009: 'Batch registration failed',
    29040003: 'This product is not exportable',
    35000003: 'Only quotation requests in unsubmitted status can be submitted',
    35000004: 'Only unpaid or failed orders can be paid',
    210000390: 'SKU is already bound, please do not repeat binding',
    210000391: 'Required: Please select a shipping option',
    210000393:
      'If the number of product attributes exceeds 100, the product cannot be automatically registered',
    210000394: 'There are products with insufficient inventory',
    210000395: 'Please select a product option',
    210001271:
      'Incomplete store URL or access token input. Please confirm the content and try again',
    220101012: 'Delivery confirmation failed',
    220101015:
      'The order was completed without approval and cannot be prioritized for shipment at the moment',
    240200067:
      'Please enter a different store name for the registered store name',
    240201001:
      'Unable to find the corresponding PayPal payment request, please contact online customer service',
    240201002:
      'It is not a payment request from PayPal, please contact online customer service',
    240201003: 'PayPal payment completed',
    240201004:
      'The payment process for PayPal has not been completed yet. Please follow the steps to complete the payment process',
    240201005:
      "Unable to access PayPal's payment procedures page. Please follow the steps to complete the payment procedures",
    240201006: 'Payment not completed, please try the payment process again',
    240201007:
      'Unable to confirm the billing address registered by the financial institution, or exceeding the usage limit of the shopping cart, the settlement was refused by the credit card company. Could you please confirm directly with the credit card issuing company',
    240201008: 'Please contact PayPal directly for incomplete PayPal payment',
    240300006:
      'There is an application in the correspondence, please apply again after processing is completed',
    240300010:
      'Registered email address, please enter a different email address',
    240300011:
      'Error: The invitation code is incorrect. Please confirm and make the correct changes',
    240300012:
      'The live broadcast has been scheduled, and there is no need to give it again',
    240300023:
      'This account has already been linked, please login and release the link, and then proceed again with the desired account.',
    240300024:
      'Since the account you have is already linked to another account, you cannot have a union with the current account',
    240300025: 'Linkage failed. This account is not eligible.',
    240300027:
      'The operation is disabled. Please perform API cooperation again.',
    280203014:
      'Please pay the membership fee after the recharge account balance is insufficient funds',
    350000103: 'The scheduled arrival date cannot be set within the past date',
    2000008001:
      'The expected delivery time cannot be less than the current time.',
    24000000: 'Product details do not exist',
    24010005:
      'This username is already in use. Please enter a different username',
    24010052:
      'Please resend the invalid authentication code and enter the correct authentication number',
    24010054:
      'The authentication code is invalid. Please send the authentication code again. Please enter the correct authentication number',
    24010055:
      'This phone number has already been registered. Please register a different phone number',
    24010056: 'This phone number is not registered',
    24130002: 'Sorry, this product cannot be purchased on behalf of others',
    219100001: 'The maximum number of downloads of watermark free images has been reached',
    220101019: '[Error] There are products without a brand license',
    240000011: '[Error] The brand has stopped exhibiting',
    240300007:
      'If the password is incorrect 5 times within 30 minutes, please use the email address',
    241000005: '[Error] Brand license application cannot be cancelled',
    241000006: '[Error] The operating status of the brand has been changed',
    241000008: '[Error] Cannot repeat application',
    22040014: 'Please enter the mailbox',
    240000012: 'Blacklisted products are not supported for place order',
    29040005: 'Blacklisted products are not supported for place order',
    240000015: 'Bulk limited shipment over the limit, limit 200',
    240000016: 'Selected orders can not be prioritized shipping',
    240000017: 'There is already an early shipment task',
    22010092: 'Unable to order due to insufficient OEM inventory',
    21000036: 'The store binding relationship has been modified, please refresh the page and reoperate',
    240000018: 'The number of linked products has exceeded the limit.',
    22041027: 'Same amazon sku exists, please ship separately!',
    210000403: 'The number of products bound to the current third-platform product is more than 3, please make it to less than 3 before operation.',
    22030001: 'The product is not in the store, please try again.',
    210000404: 'Do not allow many-to-many product linkage',
    21000403: 'The number of products bound to the current third-platform product is more than 3, please make it to less than 3 before operation.',
    240000020: 'Your selected add-on service have been updated, please re-edited it',
    210000402: 'Bundle up to 30 products',
    240000014: 'Incomplete purchase quantity.\n Purchase quantity does not meet minimum lot size.',
    240000038: 'The maximum number of table data is 1,000 rows.',
    22030012: 'The product does not exist',
    // 店铺未配置水洗标模版
    240000035: 'The store has not yet configured the washing label template',
    29050003: 'This store is not in the buying market',
    29030006: 'This store is not in the buying market',
    22050014: 'This combination product does not belong to the current store.',
    241000017: 'This brand has been exclusively licensed by someone else',
    240000030: 'The sku of the ordered product is duplicated, please check the product in the shopping cart.',
    22010091: 'Only orders that are waiting to be paid can be repaid',
    20001006: 'Please select specifications.',
    240000049: 'Non-members do not support this additional item. Please upgrade your membership.',
    240000050: 'Non-members can only place orders for ordinary items; please upgrade your membership.'
  }
}
